import React, { PureComponent, Fragment } from 'react'
import { Grid, ListItem } from '@material-ui/core'
import {
  EditableSwitch,
  EditableReactSelectCreatable,
  EditableNumericInput,
  EditableReactSelect,
} from '../common/EditableComponents'

export default class NotificationItem extends PureComponent {
  addMask = (value) => {
    if (value.length === 14) {
      return value
    } else {
      let str1 = value.substring(0, 3)
      let str2 = value.substring(3, 6)
      let str3 = value.substring(6, 10)
      return `(${str1}) ${str2}-${str3}`
    }
  }

  render() {
    const {
      index,
      label = '',
      hideEmail = false,
      notification,
      editMode,
      onChangeNotifications = () => {},
      onChangeCreatableOptions = () => {},
      terminals = {},
      onChangeShopNotifications = () => {},
      onChangeNotificationTerminals = () => {},
      dataShop = {},
    } = this.props

    let defaultEmail =
      notification.defaultEmail && notification.defaultEmail != null
        ? notification.defaultEmail.split(',')
        : []
    let defaultNumber =
      notification.defaultNumber && notification.defaultNumber != null
        ? notification.defaultNumber.split(',')
        : []
    return (
      <ListItem>
        <Grid container alignItems="center">
          <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
            {label}
          </Grid>
          <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
            <EditableSwitch
              valueToRender={notification.active ? 'Enabled' : 'Disabled'}
              editMode={editMode}
              checked={notification.active}
              onChange={onChangeNotifications(index, 'active')}
            />
          </Grid>

          {!hideEmail ? (
            <Fragment>
              <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                Send email to:
              </Grid>
              <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
                <EditableReactSelectCreatable
                  multi={true}
                  value={
                    defaultEmail && defaultEmail.map((source) => ({ label: source, value: source }))
                  }
                  onChange={(options) => onChangeCreatableOptions(index, 'defaultEmail', options)}
                  valueToRender={defaultEmail && defaultEmail.join(', ')}
                  editMode={editMode}
                  options={
                    defaultEmail && defaultEmail.map((source) => ({ label: source, value: source }))
                  }
                  clearable={false}
                />
              </Grid>
            </Fragment>
          ) : null}
          {notification.notificationType === 'Incoming_Order' ? (
            <Grid container>
              <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                Send SMS to:
              </Grid>
              <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
                <EditableReactSelectCreatable
                  multi={true}
                  value={
                    (defaultNumber.length > 0 &&
                      defaultNumber.map((source) => ({ label: source, value: source }))) ||
                    defaultNumber
                  }
                  onChange={(options) => onChangeCreatableOptions(index, 'defaultNumber', options)}
                  valueToRender={
                    defaultNumber && defaultNumber.map((number) => this.addMask(number)).join(', ')
                  }
                  editMode={editMode}
                  options={
                    defaultNumber &&
                    defaultNumber.map((source) => ({ label: source, value: source }))
                  }
                  clearable={false}
                />
              </Grid>
              <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                Restrict Incoming Order Notifications
              </Grid>
              <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
                <EditableSwitch
                  valueToRender={
                    dataShop.restrictIncomingOrderNotifications ? 'Enabled' : 'Disabled'
                  }
                  checked={dataShop.restrictIncomingOrderNotifications}
                  editMode={editMode}
                  onChange={onChangeShopNotifications('restrictIncomingOrderNotifications', true)}
                />
              </Grid>
              <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                Restricted Notification Terminals
              </Grid>
              <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
                <EditableReactSelect
                  className="terminal-select"
                  multi={true}
                  value={dataShop.restrictedNotificationTerminals}
                  onChange={onChangeNotificationTerminals('restrictedNotificationTerminals')}
                  valueToRender={
                    dataShop.restrictedNotificationTerminals &&
                    dataShop.restrictedNotificationTerminals
                      .map((terminalId) => {
                        const terminal =
                          terminals.values &&
                          terminals.values.find((terminal) => terminal.id === terminalId)
                        return (terminal && terminal.name) || ''
                      })
                      .join()
                  }
                  editMode={editMode}
                  options={
                    terminals &&
                    terminals.values &&
                    terminals.values.length &&
                    terminals.values.map((terminal) => ({
                      label: terminal.name,
                      value: terminal.id,
                    }))
                  }
                  clearable={false}
                />
              </Grid>
            </Grid>
          ) : null}
          {notification.notificationType === 'CashDrawer_Limit_Exceeds' ? (
            <Fragment>
              <Grid container>
                <Grid className="labelField margin-bottom" item xs={12} sm={6} md={6} lg={6}>
                  Max Cash Drawer Limit
                </Grid>
                <Grid className="editField margin-bottom-small" item xs={12} sm={6} md={6} lg={6}>
                  <EditableNumericInput
                    placeholder=""
                    valueToRender={notification.maxCashDrawerLimit}
                    value={notification.maxCashDrawerLimit}
                    className="numeric-material-input"
                    mobile={false}
                    onChange={(options) =>
                      onChangeCreatableOptions(index, 'maxCashDrawerLimit', options)
                    }
                    min={1}
                    precision={0}
                    editMode={editMode}
                  />
                </Grid>
              </Grid>
            </Fragment>
          ) : null}
        </Grid>
      </ListItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationItem.js